// main landing screen
import { useState } from "react";
import { useHistory } from "react-router-dom";

import { Typography, Row, Col } from 'antd';

import ContentFormatXZ from "../content/webz/content-format-xz";

import WebbDividerMedium from "../content/webx/webb-divider-md";
import WebbDividerSmall from "../content/webx/webb-divider-sm";

import wise from "../media/wise.png";

const data = [
  {name: 'Email', icon:'bi-envelope', link: 'account/mail', actv: true},
  {name: 'Mobile', icon:'bi-phone', link: 'account/mobile', actv: true},
  {name: 'Web3', icon:'bi-globe2', link: 'account/web3', actv: false}
]

const { Title } = Typography;

const media = 'https://img.freepik.com/free-vector/gradient-dynamic-lines-background_23-2148996215.jpg?t=st=1653933505~exp=1653934105~hmac=a7392bd684937b7c9b2ec73fa6f2662ed1cb72bb276badc61ab2400c346b47e3&w=826'

export default function Main () {
  
  const history = useHistory();

  const [meta, setMetamask] = useState(window.ethereum)

  return(
    <>
      <div class="page-bg"></div>      
        <div class="animation-wrapper">
          <div class="particle particle-1"></div>
          <div class="particle particle-2"></div>
          <div class="particle particle-3"></div>
          <div class="particle particle-4"></div>
        </div>
      <div className=""   
        // style={{
        //   backgroundImage:`url(${media})`, 
        //   backgroundRepeat:'no-repeat', 
        //   backgroundSize:'cover',
        //   height:'100vh'
        // }}
      >

        <Row>
        <Col xs={0} md={6} lg={9}></Col>
        <Col xs={24} md={12} lg={6}>
            <WebbDividerMedium />
            <WebbDividerMedium />
            <div className="back-color-wite text-center mx-3">
              <WebbDividerSmall />
              <WebbDividerMedium />
              <i className='bx bx-globe text-color-main text-icon-wd'></i>
              <WebbDividerMedium />
              <Title><span className="text-color-main">{process.env.REACT_APP_WEBB_SITE_NAME}</span></Title>
              <p className="text-lead m-0">{process.env.REACT_APP_WEBB_SITE_LINE}</p>
              <div className="" style={{height:'15vh'}}></div>
              <img src={wise} className="media-auto"></img>
            </div>

            <WebbDividerSmall />
            <WebbDividerSmall />
            <p className="text-color-wite text-center m-0">Connect Your Account</p>
            
            <WebbDividerSmall />
            <WebbDividerSmall />
            <div className=" mx-3">



            <div className={`p-1 px-2 back-color-wite hilite`}
              style={{cursor:'pointer'}}
              onClick={() => history.push('/auth/mail')}
            >
              <Row justify="space-between">
                <Col span={21}>
                  <Row justify="start" align="middle">
                    <Col>
                      <i className="lead bx bx-envelope text-color-main m-0 text-icon-sm"></i>
                    </Col >
                    <Col flex="auto" className="mx-1">Login via Email</Col>
                  </Row>
                </Col>

                <Col span={3} className="text-end">
                  <i className="bx bx-chevron-right text-color-tone m-0 text-icon-sm" ></i>
                </Col>
              </Row>
            </div>

            <WebbDividerSmall />
            <div className={`p-1 px-2 back-color-wite hilite d-none`}
              style={{cursor:'pointer'}}
              onClick={() => history.push('/auth/mail')}
            >
              <Row justify="space-between">
                <Col span={21}>
                  <Row justify="start" align="middle">
                    <Col>
                      <i className="lead bx bx-globe text-color-main m-0 text-icon-sm"></i>
                    </Col >
                    <Col flex="auto" className="mx-1">Login via Metamask</Col>
                  </Row>
                </Col>

                <Col span={3} className="text-end">
                  <i className="bx bx-chevron-right text-color-tone m-0 text-icon-sm" ></i>
                </Col>
              </Row>
            </div>

            </div>

            </Col>
          <Col xs={0} md={6} lg={9}></Col>

        </Row>


      </div>

    </>
  )
}